import cn from 'classnames'

import { useTranslation } from '../../../utils/use-translation'

import styles from './styles.module.scss'

export default function CopiedMessage({ className = undefined }) {
  const { t } = useTranslation()

  return typeof t !== 'undefined' ? <span className={cn(styles.message, className)}>{t('copied')}</span> : <></>
}
